import React from "react";
import { duration } from "../lib/format";

export default function ScanProgress({ active, scanned = 0, total = 0, sector, elapsed = 0, message }) {
  if (!active) return null;
  const pct = total > 0 ? Math.min(100, Math.round((scanned / total) * 100)) : 0;
  return (
    <div
      className="card"
      role="status"
      aria-live="polite"
      style={{ padding: "12px 16px", display: "flex", flexDirection: "column", gap: 8 }}
    >
      <div style={{ display: "flex", gap: 12, alignItems: "center", fontSize: 12, flexWrap: "wrap" }}>
        <span className="pill info">SCANNING</span>
        {sector && <span style={{ fontWeight: 500 }}>{sector}</span>}
        <span className="num" style={{ color: "var(--muted)" }}>
          {scanned} / {total || "?"} stocks
        </span>
        <span className="num" style={{ color: "var(--muted)" }}>
          {duration(elapsed)} elapsed
        </span>
        {message && <span style={{ color: "var(--muted)" }}>{message}</span>}
        <span className="num" style={{ marginLeft: "auto", color: "var(--muted)" }}>
          {pct}%
        </span>
      </div>
      <div className="progress-bar">
        <span style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
